import { Modal } from 'antd'
import React from 'react'
import strings from '../../../../../../strings';
import CartList from '../../../../../Sales/_partials/CartList';
import moment from 'moment';

const MtierTransactionDetails = ({
    open,
    onCancel,
    transactionDetails,
    result,
    user
}) => {
    const {
        has_discount,
        discount_amount,
        channel,
        payment_reference,
        paymentType,
        reference_code,
        transactions,
        customerName,
        invoice_id,
        mtier_amount,
        transaction_type,
        staff,
        customer,
        id,
        transaction_date, 
        payment_label,
        net_vat
      } = transactionDetails;

    console.log("hjhj", transactionDetails);
    const handleCalculatePoint = (amount) => {
        const activeLoyalty = result && result.listLoyalties.find(loyalty => loyalty.status === "Active");
    
        if(activeLoyalty) {
          const points = activeLoyalty.points;
          const currencyValue = activeLoyalty.currency_value;
          const pointSpent = (Number(amount) * Number(points)) / Number(currencyValue);
    
          return pointSpent.toFixed(2);
          
        }
      }
    
  return (
    <Modal
        open={open}
        onCancel={onCancel}
        title={`${strings.transactionDetails}`}
        footer={null}
    >
        <div>
             <p>
                <strong>{strings.customerName}</strong>:{" "}
                {`${customer ? `${JSON.parse(customer).first_name} ${JSON.parse(customer).last_name || ""}` : "-"}`}
            </p>

            <p>
                <strong>{strings.servedBy}</strong>:{" "}
                {staff ? JSON.parse(staff).username : strings.admin}
            </p>
            <p>
                <strong>{strings.transDate}</strong>: {transaction_date && moment(transaction_date).format(
                    "DD-MM-YYYY hh:mm a"
                )}
            </p>
            <p>
                <strong>{strings.transactionType}</strong>: {" "}
                {transaction_type || "N/A"}
            </p>
            <p>
                <strong>{strings.mtierAmount}</strong>: {" "}
                {user.currency} {" "}
                {mtier_amount || "0"}
            </p>
            <p>
                <strong>{strings.pointUsed}</strong>: {" "}
                {/* {mtier_amount && currency} */}
                {handleCalculatePoint(mtier_amount) || "0"}
            </p>
            <p>
                <strong>{strings.products}</strong>
            </p>
            <div className="cart details-cart">
                {JSON.parse(transactions) && (
                <CartList
                    data={JSON.parse(transactions)}
                    increaseItemQuantity={null}
                    removeItemFromCart={null}
                    reduceItemFromCart={null}
                    handleShowBulkModal={null}
                    // returnItem
                    // onClickReturn={handleReturnItem}
                    // returnLoading={returnLoading}
                    // returnOneItem={returnOneItem}
                    // setSelectedItem={setSelectedItem}
                    // setOpenManangeReturnModal={setOpenManangeReturnModal}
                    // getAllSales={getAllSales}
                />
                )}
            </div>
        </div>
    </Modal>
  )
}

export default MtierTransactionDetails